/// <amd-module name="VSS/Features/Frame/AssetResolver" />
export * from "./AssetResolver/index";
